<template>
	<div class="threedrotate">
		<div class="topcon">
			<div class="l_c">
				<div v-for="(item,index) in list" :key="index" @click="changebla(index)"
				:class="index == signindex?'signlecon_cur':'signlecon'">
					{{item.title.substring(0,8) || ''}}
					<span v-show="item.title.length>8">...</span>
				</div>
			</div>
			<div class="r_c">
				<div class="morebtn" @click="topublicbenact">更多公益活动</div>
			</div>
		</div>
		
		<el-carousel :interval="4000" type="card" height="416px" 
		loop indicator-position="none" @change="changetab" ref="img">
		    <el-carousel-item v-for="(item,index) in list" :key="index">
		         <!-- <h3 class="medium">{{ item }}</h3> -->
					 <el-image fit='cover' class="imgcon" :src="getFileAccessHttpUrl(item.breviaryMap)" :title="item.title" ></el-image>
				 <div class="modelcon">{{item.title || ''}}</div>
		    </el-carousel-item>
		</el-carousel>

		<div class="details">{{list[signindex] != undefined?gethypertext(list[signindex].content):''}}</div>
		<div class="btncon">
			<div class="btn" @click="toDatail(signindex,list[signindex])">查看详情</div>
		</div>
		
	</div>
	
</template>

<script>


export default {

  data: function() {
		return {
			signindex:0,
			list:[],
		  
		};
  },
  
  created() {
     // this.getthpWebCarousel();
  },
  
  methods: {
		getthpWebCarousel() {
			  var that = this;
			  this.httpGet("web/info/list", {
				infoType:"0",
				pageNo: 1,
				pageSize: 3,
				title:""
			  }).then(res => {
			  		that.list = res.result.records;
			 
			  });
		},
		
		changetab(e){
			// console.log(e)
			this.signindex = e
		},
		
		changebla(index){
			this.signindex = index
			this.$refs.img.setActiveItem(index) //调动setActiveItem方法，动态切换图片
		},
	  
		topublicbenact(){
			this.$router.push({ path: '/publicbenact', query: {} });
			
		},
		
		//过滤富文本
		gethypertext(str){
			  if(str == null){
					return "";
			  }
			  var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
			              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
			  str = str.substring(0,100);
			  return str;
		},
		
		toDatail(indexsign,item){
			this.$router.push({ path: '/benefitactivitiesdetail', query: {index:indexsign,id:item.id} });
		},
		
	
  },
  
  mounted() {
	 this.getthpWebCarousel();	
  }
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.threedrotate{
	
	height: 700px;
	width: 900px;
	.topcon{
		height:80px;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.l_c{
			display: flex;
			align-items: center;
			.signlecon_cur,.signlecon{
				cursor: pointer;
				width: 210px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-radius: 20px;
				font-size: 16px;
				font-weight: 400;
				margin-right: 20px;
			}
			.signlecon_cur{
				color: #FFFFFF;
				background: #D80C18;
			}
			.signlecon{
				color: #333333;
				border: 1px solid #D80C18;
			}
			.signlecon:hover{
				color: #FFFFFF;
				background: #D80C18;
			}
		}
		.r_c{
			.morebtn{
				cursor: pointer;
				width: 120px;
				height: 34px;
				line-height:34px;
				text-align: center;
				border: 1px solid #CCCCCC;
				border-radius:17px;
				font-size:16px;
				font-weight: 400;
				color: #999999;
			}
		}
	}
	
	.el-carousel__item{
		width:700px;
		margin-left: -120px;
	}
	
	.el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;		
	}
	  
	.el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
		
	}
	
	.el-carousel__indicators{
		display: none;
	}
	
	.imgcon{
		width: 100%;
		height: 100%;
	}
	
	.modelcon{
		position: absolute;
		bottom: 0px;
		width: 100%;
		height: 48px;
		line-height: 48px;
		text-align: center;
		background: rgba(0,0,0,0.6);
		font-size: 18px;
		font-weight: 400;
		color: #FFFFFF;
	}
	
	.details{
		margin-top: 40px;
		margin-left: 120px;
		margin-right: 120px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
	} 
	
	.btncon{
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top:20px;
		.btn{
			cursor: pointer;
			width: 120px;
			height: 32px;
			line-height: 32px;
			text-align: center;
			border: 1px solid #E50112;
			border-radius: 15px;
			font-size: 16px;
			font-weight: 400;
			color: #E50112;
		}
	} 
	
	
	
}

</style>
